import React from 'react';

class TemplateFetcher extends React.Component {
  constructor(props) {
    super(props);
    this.url = props.url;
    this.state = {
      data: null,
      isLoading: false,
      error: null,
    };
  }

  componentDidMount() {
    fetch(this.url)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((data) => {
        this.setState({ data: data.results[0].value, isLoading: false });
      })
      .catch((error) => this.setState({ error, isLoading: false }));
  }

  setState(state) {
    const { onChangeLoading } = this.props;
    const { onChangeTemplates } = this.props;
    if (this.state.isLoading !== state.isLoading) {
      onChangeLoading(state.isLoading);
    }
    if (this.state.data !== state.data) {
      const data = state.data.map((i) => {
        return {
          value: i.name,
          width: i.dimx < 100 ? i.dimx * 10 : i.dimx,
          height: i.dimy < 100 ? i.dimy * 10 : i.dimy,
          display: i.name.replace(/_/g, ' ').replace(/Legend/g, ''),
        };
      });
      onChangeTemplates(data);
      onChangeLoading(false);
    }
    const retVal = super.setState(state);
    return retVal;
  }

  render() {
    return null;
  }
}

export default TemplateFetcher;
